module.exports = __webpack_public_path__ + "static/img/logo-5.110280b6.png";